import Vue from "vue";
import VueI18n from "vue-i18n";
import euiZhLocale from "element-ui/lib/locale/lang/zh-CN";
import euiEnLocale from "element-ui/lib/locale/lang/en";
import ElementLocale from "element-ui/lib/locale";
import sysZhLocale from "@/locales/zh.json";
import sysEnLocale from "@/locales/en.json";
import store from "@/store";

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.currentLocale,
  messages: {
    zh: {
      ...sysZhLocale,
      ...euiZhLocale
    },
    en: {
      ...sysEnLocale,
      ...euiEnLocale
    }
  }
});

i18n.setLocale = function (locale) {
  store.commit('setCurrentLocale', locale);
  this.locale = store.state.currentLocale;

  // 因 element-ui validation rules 在切换语系时不会重新载入错误讯息
  // 故在切换语系时同时进行页面重整
  location.reload();
}

i18n.getLocale = function () {
  return this.locale;
}

ElementLocale.i18n((key,value) => i18n.t(key,value));

export default i18n;